module.exports = __webpack_public_path__ + "static/assets/be994feda7f03eb9f7e3f52b1a11304d.svg";